import { Line } from "src/core/models/line_model";

export type LineState = {
  loading: boolean | false;
  adding: boolean | false;
  updating: boolean | false;
  deleting: boolean | false;
  hasMore: boolean;
  data: Line[] | [];
  code?: string;
  message?: string;
};

export const LineInitialState: LineState = {
  loading: false,
  adding: false,
  updating: false,
  deleting: false,
  hasMore: false,
  data: [],
};
